<app-playlist [playlistArticles]="playlistArticles$ | async"></app-playlist>
